import React from 'react';
import {Route, Switch} from 'react-router-dom';
import ManageArticleListPage from './manage/articleList';
import ManageUserListPage from './manage/userList';
import ManageSystemPage from './manage/system';
import ManageManagerListPage from './manage/managerList';
import ManagePaymentList from './manage/paymentList';
import ManageCongressTablePage from './manage/congressTableList';
import ManageDoubleMemberList from './manage/doubleMemberList';

export default function ManageRouter() {
  return (
    <Switch>
      <Route path={'/manage/article'} component={ManageArticleListPage} />
      <Route path={'/manage/user'} component={ManageUserListPage} />
      <Route path={'/manage/manager'} component={ManageManagerListPage} />
      <Route path={'/manage/system'} component={ManageSystemPage} />
      <Route path={'/manage/payment'} component={ManagePaymentList} />
      <Route path={'/manage/congress'} component={ManageCongressTablePage} />
      <Route path={'/manage/doubleMember'} component={ManageDoubleMemberList} />
    </Switch>
  );
}
